import { Link } from 'react-router-dom';
import Canvas from '../components/Canvas';
import MainFooter from '../components/MainFooter';
import { useEffect, useLayoutEffect, useRef, useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { gsap } from 'gsap';
import { LoadingContext } from '../App';


function Home() {
    const videoReviewRef = useRef<HTMLDivElement>(null);
    const videoLinkRef = useRef<HTMLLinkElement | null>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const videoRef2 = useRef<HTMLVideoElement>(null);
    const [isMuted, setIsMuted] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPlaying2, setIsPlaying2] = useState(false);

    const togglePlay = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                if (videoRef2.current && !videoRef2.current.paused) {
                    videoRef2.current.pause();
                    setIsPlaying2(false);
                }
                videoRef.current.play();
                setIsPlaying(true);
                // Explicitly unmute on user interaction to satisfy browser policy
                videoRef.current.muted = false;
                setIsMuted(false);
            } else {
                videoRef.current.pause();
                setIsPlaying(false);
            }
        }
    };

    const togglePlay2 = () => {
        if (videoRef2.current) {
            if (videoRef2.current.paused) {
                if (videoRef.current && !videoRef.current.paused) {
                    videoRef.current.pause();
                    setIsPlaying(false);
                }
                videoRef2.current.play();
                setIsPlaying2(true);
                // Explicitly unmute on user interaction to satisfy browser policy
                videoRef2.current.muted = false;
                setIsMuted(false);
            } else {
                videoRef2.current.pause();
                setIsPlaying2(false);
            }
        }
    };

    useEffect(() => {
        // Load the custom CSS for this section
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/home-video.css';
        document.head.appendChild(link);
        videoLinkRef.current = link;

        return () => {
            // Clean up: remove the CSS when component unmounts
            if (videoLinkRef.current && document.head.contains(videoLinkRef.current)) {
                document.head.removeChild(videoLinkRef.current);
            }
        };
    }, []);

    // Force scroll to top on mount
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        // If GSAP is already loaded, teleport to top
        if (window.ScrollSmoother && window.ScrollSmoother.get()) {
            window.ScrollSmoother.get().scrollTop(0);
        }
    }, []);

    const { setIsPageReady } = useContext(LoadingContext);

    useEffect(() => {
        let ctx: gsap.Context;
        const timer = setTimeout(() => {
            ctx = gsap.context(() => {
                if (videoReviewRef.current) {
                    const el = videoReviewRef.current;
                    const revealItems = el.querySelectorAll('.reveal-anim');

                    revealItems.forEach((item) => {
                        gsap.fromTo(item, 
                            { opacity: 0, y: 50 },
                            { 
                                opacity: 1, 
                                y: 0, 
                                duration: 1, 
                                ease: "power2.out",
                                scrollTrigger: {
                                    trigger: item,
                                    start: "top 85%",
                                    toggleActions: "play none none none"
                                }
                            }
                        );
                    });
                }
            });

            // Signal that the page is ready
            setIsPageReady(true);
        }, 500); // Wait for main.js and LoadScript to finish

        return () => {
            clearTimeout(timer);
            if (ctx) ctx.revert();
        };
    }, [setIsPageReady]);


    return (
        <>
            <Helmet>
                <title>India's #1 Web Designing Company in Ahmedabad | Sacesta Technologies</title>
                <meta name="description" content="Sacesta Technologies is India's #1 Web Designing Company in Ahmedabad, offering high-impact web solutions, software development, and digital transformation. Branding & GHL CRM Automation Experts." />
                <meta name="keywords" content="web development Ahmedabad, software solutions India, digital transformation, Sacesta, branding, GHL CRM Automation, GoHighLevel Experts" />
                <link rel="canonical" href="https://sacesta.com/" />
                
                {/* JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LocalBusiness",
                        "name": "Sacesta Technologies",
                        "image": "https://sacesta.com/assets/imgs/logo/site-logo-white-2.png",
                        "@id": "https://sacesta.com/",
                        "url": "https://sacesta.com/",
                        "telephone": "+91 8347406455",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "Ahmedabad",
                            "addressLocality": "Ahmedabad",
                            "addressRegion": "Gujarat",
                            "postalCode": "380015",
                            "addressCountry": "IN"
                        },
                        "geo": {
                            "@type": "GeoCoordinates",
                            "latitude": 23.0225,
                            "longitude": 72.5714
                        },
                        "openingHoursSpecification": {
                            "@type": "OpeningHoursSpecification",
                            "dayOfWeek": [
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            "opens": "09:00",
                            "closes": "19:00"
                        },
                        "sameAs": [
                            "https://www.linkedin.com/company/sacesta",
                            "https://www.instagram.com/sacesta_technologies/"
                        ]
                    })}
                </script>

                {/* FB / WhatsApp sharing */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://sacesta.com/" />
                <meta property="og:title" content="Sacesta Technologies | Branding & Development Agency" />
                <meta property="og:description" content="Sacesta Technologies specializes in high-impact web solutions, branding, and CRM automation. Discover our work and book a meet today." />
                <meta property="og:image" content="https://sacesta.com/assets/imgs/logo/site-logo-white-2.png" />
            </Helmet>
            <div className="cursor1"></div>
            <div className="cursor2"></div>

            <div className="has-smooth" id="has_smooth"></div>

            <button id="scroll_top" className="scroll-top"><i className="fa-solid fa-arrow-up"></i></button>

            <header className="header__area-3">
                <div className="header__inner-3">
                    <div className="header__logo-2">
                       
                        <Link to="/" className="logo-dark">
                            <img src="assets/imgs/logo/sacesta-logo-black.png" style={{width : '150px' , height:'40px' }} alt="Site Logo" />
                        </Link>
                        <Link to="/" className="logo-light"><img src="assets/imgs/logo/site-logo-white-2.png"
                            alt="Site Logo" /></Link>
                    </div>
                    <div className="header__nav-2">
                        <ul className="main-menu-3 menu-anim">
                            <li className="has-megamenu">
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="about">about</Link>
                            </li>
                            <li className="has-megamenu">
                                <Link to="/our-work">Our Work</Link>
                            </li>
                            <li><a href="https://calendly.com/sacesta/30min">Book A Meet</a></li>
                        </ul>
                    </div>
                    <div className="header__nav-icon-3">
                        <button className="search-icon" id="search_icon"><i className="fa-solid fa-magnifying-glass"></i></button>
                        <button className="search-icon" id="search_close"><i className="fa-solid fa-xmark"></i></button>
                        <button id="open_offcanvas"><img src="assets/imgs/icon/menu-black.png" alt="Menubar Icon" /></button>
                    </div>
                </div >
            </header >
            <div className="header__search">
                <form action="#">
                    <input type="text" name="s" id="s" placeholder="Search.." />
                </form>
            </div>
            {/* Header area end  */}

            {/* <?php include "includes/canvas.php" ?> */}
            <Canvas />

            <div id="smooth-wrapper">
                <div id="smooth-content">
                    <main>

                        <section className="hero__area-3">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-12">
                                        <div className="hero__inner-3">
                                            <div className="sec-title-wrapper">
                                                <h2 className="sec-sub-title">Digital</h2>
                                                <h3 className="sec-title title-left">Dimens</h3>
                                                <h3 className="sec-title title-right">ions</h3>
                                            </div>
                                            <div className="hero__text-3">
                                                <p className="hero__text-animation">We craft high-impact web solutions that fuel your growth, and establish a digital presence that shines on any screen. Let's collaborate and turn your digital dreams into reality</p>
                                            </div>
                                            <div className="scroll-down">
                                                <button><img src="assets/imgs/icon/arrow-down-sm.png" alt="arrow icon" /></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="video-info">
                                    <div className="video-intro">
                                        <input id="video_check" type="checkbox" />
                                        <div className="intro-title">
                                            <h4 className="video-title">Watch <span>video intro</span></h4>
                                            <h4 className="video-title close-video-title">Close <span>video intro</span></h4>
                                        </div>
                                        <div className="video">
                                            <video
                                                src="assets/video/Website intro.mp4"
                                                loop muted autoPlay playsInline></video>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="hero3-img-ani">
                                <img src="assets/imgs/hero/3/1.jpg" alt="Hero" className="hero3-img" />
                            </div>
                        </section>


                        {/* <!-- Brand area start --> */}
                        <section className="brand__area">
                            <div className="container pt-140 pb-140">
                                <div className="row">
                                    <div className="col-xxl-12">
                                        <h2 className="brand__title-3 title-anim">A launchpad to your success
                                        </h2>
                                        <div className="brand__list-3">
                                            <div className="brand__item-2 fade_bottom">
                                                <img src="assets/imgs/brand/1.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item-2 fade_bottom">
                                                <img src="assets/imgs/brand/2.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item-2 fade_bottom">
                                                <img src="assets/imgs/brand/3.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item-2 fade_bottom">
                                                <img src="assets/imgs/brand/4.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item-2 fade_bottom">
                                                <img src="assets/imgs/brand/5.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item-2 fade_bottom">
                                                <img src="assets/imgs/brand/6.png" alt="Brand Logo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                        <section className="about__area-3">
                            <div className="container pt-140 pb-110">
                                <div className="row">
                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                        <div className="about__img-3">
                                            <img src="assets/imgs/about/3/1.jpg" alt="About Thumbnail" data-speed="auto" />
                                        </div>
                                    </div>

                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                        <div className="sec-title-wrapper">
                                            <h2 className="sec-sub-title title-anim">We Are SACESTA</h2>
                                            <h3 className="sec-title title-anim">Stuck navigating the complex currents of online transformation and product development?.</h3>
                                        </div>
                                        <div className="sec-text-wrapper">
                                            <div className="sec-text text-anim">
                                                <p>Imagine your brand taking flight dominating the digital landscape, powered by solutions that dazzle the customers and deliver to the stakeholders. We're more than coders, we're your global collaborators, transforming your vision into high-octane digital engines. We're your partners in progress. Whether you're a budding entrepreneur or an established brand, Sacesta can help you simplify the digital journey and supercharge the growth. So, let's craft your digital story together.</p>
                                                <div className="btn_wrapper">
                                                    <a className="wc-btn-light btn-hover btn-item"
                                                        href="https://calendly.com/sacesta/30min"><span></span> Schedule a meet. <i
                                                            className="fa-solid fa-arrow-right"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="service__area-3 pb-150">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-12">
                                        <div className="sec-title-wrapper pt-130 text-anim">
                                            <h2 className="sec-sub-title title-anim">Services</h2>
                                            <h3 className="sec-title title-anim">Our <br /> Services</h3>
                                            <p>We're not your average consultants. Sacesta dives deep, crafting clear strategies and building products that work.  We empower you to adapt, evolve, and dominate the digital ocean.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xx-12">
                                        <div className="service__list-3">

                                            <div className="service__item-3 service_animation">
                                                <h3><a href="#/" className="service__title-3 ">Website <br />Development</a></h3>
                                                <div className="service__content-3">
                                                    <p>We create customized designs that reflect your brand identity, optimize your website for search engines, and implement responsive layouts for a flawless experience on any device.
                                                    </p>
                                                    <ul className="">
                                                        <li>+ ReactJS / AngularJS / VueJS  </li>
                                                        <li>+ NextJS / Svelte / Ionic  </li>
                                                        <li>+ Node Js / Php / Laravel </li>
                                                        <li>+ MySQL / MongoDB / PostgreSQL </li>
                                                        <li>+ Wordpress / Shopify / Webflow</li>
                                                    </ul>
                                                </div>
                                                <div className="service__btn-3">
                                                    <div className="btn_wrapper">
                                                        <a href="https://calendly.com/sacesta/30min"
                                                            className="wc-btn-black btn-hover btn-item"><span></span> Connect Now
                                                            <i className="fa-solid fa-arrow-right"></i></a>
                                                    </div>
                                                </div>

                                                <div className="service__hover-3"
                                                    style={{ backgroundImage: 'url(assets/imgs/service/3/2.png)' }}></div>
                                            </div>

                                            <div className="service__item-3 service_animation">
                                                <h3><a href="#/" className="service__title-3">App <br /> Development</a></h3>
                                                <div className="service__content-3">
                                                    <p>Building custom apps quickly, making them easy to use and work everywhere, and keeping them online so they can grow.
                                                    </p>
                                                    <ul className="">
                                                        <li>+ Android Apps</li>
                                                        <li>+ iOS Apps</li>
                                                    </ul>
                                                </div>
                                                <div className="service__btn-3">
                                                    <div className="btn_wrapper">
                                                        <a href="https://calendly.com/sacesta/30min"
                                                            className="wc-btn-black btn-hover btn-item"><span></span> Connect Now
                                                            <i className="fa-solid fa-arrow-right"></i></a>
                                                    </div>
                                                </div>

                                                <div className="service__hover-3"
                                                    style={{ backgroundImage: 'url(assets/imgs/service/3/1.png)' }}></div>
                                            </div>



                                            <div className="service__item-3 service_animation">
                                                <h3 className=""><a href="#/" className="service__title-3">Branding &
                                                    <br />Marketing</a></h3>
                                                <div className="service__content-3">
                                                    <p>Sacesta offers innovative digital marketing solutions to help
                                                        businesses enhance their online presence and drive revenue.
                                                    </p>
                                                    <ul className="">
                                                        <li>+ Branding</li>
                                                        <li>+ Google Ads</li>
                                                        <li>+ Instagram / LinkedIn Ads</li>
                                                        <li>+ Brand Writing</li>
                                                        <li>+ Promotion</li>
                                                    </ul>
                                                </div>
                                                <div className="service__btn-3">
                                                    <div className="btn_wrapper">
                                                        <a href="https://calendly.com/sacesta/30min"
                                                            className="wc-btn-black btn-hover btn-item"><span></span> Connect Now
                                                            <i className="fa-solid fa-arrow-right"></i></a>
                                                    </div>
                                                </div>

                                                <div className="service__hover-3"
                                                    style={{ backgroundImage: 'url(assets/imgs/service/3/3.png)' }}></div>
                                            </div>

                                            <div className="service__item-3 service_animation">
                                                <h3 className=""><a href="#/" className="service__title-3">CUSTOM <br />SOLUTIONS</a></h3>
                                                <div className="service__content-3">
                                                    <p>We create innovative solutions that perfectly align with your unique business needs and challenges.
                                                    </p>
                                                    <ul className="">
                                                        <li>+ CRM Development</li>
                                                        <li>+ ERP Development</li>
                                                        <li>+ Business Process Automation</li>
                                                        <li>+ Custom Software Integration</li>
                                                    </ul>
                                                </div>
                                                <div className="service__btn-3">
                                                    <div className="btn_wrapper">
                                                        <a href="https://calendly.com/sacesta/30min"
                                                            className="wc-btn-black btn-hover btn-item"><span></span> Connect Now
                                                            <i className="fa-solid fa-arrow-right"></i></a>
                                                    </div>
                                                </div>

                                                <div className="service__hover-3"
                                                    style={{ backgroundImage: 'url(assets/imgs/service/3/4.png)' }}></div>
                                            </div>

                                            <div className="service3__img-wrap">
                                                <div className="service3__img"></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>

                        <section className="portfolio__area pb-140">
                            <div className="container">
                                <div className="row top_row">

                                    <h2 className="portfolio__text">work</h2>
                                    <div className="portfolio__list-1">
                                        <div className="portfolio__item">
                                            <a href="#/"><img className="mover" src="assets/imgs/portfolio/1/1.png"
                                                alt="Product Development" /></a>
                                            <div className="portfolio__info">
                                                <h3 className="portfolio__title">Product Development</h3>
                                                <p>02 May 2023</p>
                                            </div>
                                        </div>
                                        <div className="portfolio__item">
                                            <a href="#/"><img src="assets/imgs/portfolio/1/2.png" alt="E-Commerce" /></a>
                                            <div className="portfolio__info">
                                                <h3 className="portfolio__title">E-Commerce</h3>
                                                <p>14 Dec 2022</p>
                                            </div>
                                        </div>
                                        <div className="portfolio__item">
                                            <a href="#/"><img src="assets/imgs/portfolio/1/3.png" alt="CRM Development" /></a>
                                            <div className="portfolio__info">
                                                <h3 className="portfolio__title">CRM Development</h3>
                                                <p>22 Sept 2022</p>
                                            </div>
                                        </div>
                                        <div className="portfolio__item">
                                            <a href="#/"><img src="assets/imgs/portfolio/1/4.png" alt="NGO Web App" /></a>
                                            <div className="portfolio__info">
                                                <h3 className="portfolio__title">NGO Web App</h3>
                                                <p>4 Feb 2023</p>
                                            </div>
                                        </div>
                                        <div className="portfolio__item">
                                            <a href="#/"><img src="assets/imgs/portfolio/1/5.png" alt="Esimfox" /></a>
                                            <div className="portfolio__info">
                                                <h3 className="portfolio__title">Esimfox</h3>
                                                <p>01 April 2025</p>
                                            </div>
                                        </div>
                                        <div className="portfolio__item">
                                            <a href="#/"><img src="assets/imgs/portfolio/1/6.png" alt="Portfolio Website" /></a>
                                            <div className="portfolio__info">
                                                <h3 className="portfolio__title">Portfolio Website</h3>
                                                <p>21 Feb 2023</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="row row_bottom">
                                    <div className="col-xxl-12">
                                        <div className="portfolio__btn btn_wrapper" data-speed="1" data-lag="0.2">
                                            <a className="wc-btn-secondary btn-hover btn-item"
                                                href="https://calendly.com/sacesta/30min"><span></span>Book a Meet <br />Now <i
                                                    className="fa-solid fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* <!-- Client Video Review Section --> */}
                        <section className="client-video-section" id="client-reviews" ref={videoReviewRef}>
                            <div className="container">
                                <div className="sec-title-wrapper reveal-anim">
                                    <h2 className="sec-sub-title">Voices of Success</h2>
                                    <h3 className="sec-title">What Our Clients Say About Us</h3>
                                </div>
                                <div className="video-grid reveal-anim">
                                    <div className="video-container-wrapper">
                                        <div className="video-container" onClick={togglePlay} style={{ cursor: 'pointer' }}>
                                            <video 
                                                ref={videoRef}
                                                src="assets/video/ClientReview.mp4#t=0.1" 
                                                loop 
                                                muted={isMuted} 
                                                playsInline 
                                                preload="metadata"
                                            ></video>
                                            <button 
                                                className={`video-ctrl-btn ${!isPlaying ? 'paused' : ''}`} 
                                            >
                                                <i className={`fa-solid ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="video-container-wrapper">
                                        <div className="video-container" onClick={togglePlay2} style={{ cursor: 'pointer' }}>
                                            <video 
                                                ref={videoRef2}
                                                src="assets/video/ClientReview2.mp4#t=0.1" 
                                                loop 
                                                muted={isMuted} 
                                                playsInline 
                                                preload="metadata"
                                            ></video>
                                            <button 
                                                className={`video-ctrl-btn ${!isPlaying2 ? 'paused' : ''}`} 
                                            >
                                                <i className={`fa-solid ${isPlaying2 ? 'fa-pause' : 'fa-play'}`}></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* 
            <!-- <section className="portfolio__area-3">
              <div className="container pt-100 pb-150">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="sec-title-wrapper">
                      <h2 className="sec-sub-title title-anim">Featured <br />Work</h2>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xxl-12">
                    <div className="swiper portfolio__slider-3">
                      <div className="swiper-wrapper">
                        <div className="swiper-slide">
                          <div className="portfolio__slide-3">
                            <a href="https://ladakhbites.com">
                              <h3 className="portfolio__title-3">Ladakh <span>Bites</span> FMCG</h3>
                              <img src="assets/imgs/portfolio/3/1.jpg" alt="Portfolio" />
                            </a>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <div className="portfolio__slide-3">
                            <a href="https://srnseeds.com">
                              <h3 className="portfolio__title-3">SRN <span>Seeds</span> 2023</h3>
                              <img src="assets/imgs/portfolio/3/2.jpg" alt="Portfolio" />
                            </a>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <div className="portfolio__slide-3">
                            <a href="https://lovenya.sacesta.in">
                              <h3 className="portfolio__title-3">Lovenya <span>Travels</span> Booking
                              </h3>
                              <img src="assets/imgs/portfolio/3/3.jpg" alt="Portfolio" />
                            </a>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <div className="portfolio__slide-3">
                            <a href="https://suwish.in">
                              <h3 className="portfolio__title-3">Suwish <span>Designer</span> Clothing
                              </h3>
                              <img src="assets/imgs/portfolio/3/5.jpg" alt="Portfolio" />
                            </a>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <div className="portfolio__slide-3">
                            <a href="https://trishan.co">
                              <h3 className="portfolio__title-3">Trishan <span>Stock</span> Management
                              </h3>
                              <img src="assets/imgs/portfolio/3/6.jpg" alt="Portfolio" />
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="swiper-pagination"></div>

                      <div className="swiper-btn">
                        <div className="pp-prev"><i className="fa-solid fa-arrow-left"></i></div>
                        <div className="pp-next"><i className="fa-solid fa-arrow-right"></i></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> --> */}


                        {/* <!-- Testimonial area start --> */}
                        <section className="testimonial__area-3">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-12">
                                        <div className="swiper testimonial__slider-3">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide testimonial__slide-3">
                                                    <p>Sacesta Technologies was an absolute pleasure to collaborate with. Their professionalism and expertise were evident throughout our project. Not only was the project completed punctually, but the quality of work truly exceeded expectations. We highly recommend their services to anyone in need of reliable and skilled professionals.</p>
                                                    <h2 className="client__name-3">Zsolt H.</h2>
                                                    <h3 className="client__role-3">From Serbia</h3>
                                                </div>
                                                <div className="swiper-slide testimonial__slide-3">
                                                    <p>Sumit and his team at Sacesta Technologies demonstrated outstanding professionalism and patience in our project. Their ability to swiftly resolve bugs and maintain high standards of work has led us to award them a full-time project. The dedication shown by Sumit and Uday has been remarkable.</p>
                                                    <h2 className="client__name-3">Shekhar Sagar</h2>
                                                    <h3 className="client__role-3">Director at GetGrahak Technologies Pvt Ltd</h3>
                                                </div>
                                                <div className="swiper-slide testimonial__slide-3">
                                                    <p>With a profound understanding and extensive knowledge in coding, particularly in TypeScript, our experience with this professional was outstanding. We highly recommend their expertise for anyone seeking top-tier TypeScript development. Looking forward to more collaborative projects together. Highly recommended!</p>
                                                    <h2 className="client__name-3">Kamal Gupta</h2>
                                                    <h3 className="client__role-3">From India</h3>
                                                </div>
                                                <div className="swiper-slide testimonial__slide-3">
                                                    <p>Delivered exceptional work exactly as anticipated. The project was completed to the highest standards, meeting all our expectations. Excellent job!</p>
                                                    <h2 className="client__name-3">Lokesh P.</h2>
                                                    <h3 className="client__role-3">CTO At Paperpal</h3>
                                                </div>
                                                <div className="swiper-slide testimonial__slide-3">
                                                    <p>Exceptionally talented development team, highly recommended for their expertise and skill. Outstanding service!</p>
                                                    <h2 className="client__name-3">Eduardo M.
                                                    </h2>
                                                    <h3 className="client__role-3">From Mexico</h3>
                                                </div>
                                            </div>
                                            <div className="next-button swipper-btn"><i className="fa-solid fa-arrow-left"></i></div>
                                            <div className="prev-button swipper-btn"><i className="fa-solid fa-arrow-right"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="testimonial__images-3 animation_image_zoom">
                                <img src="assets/imgs/testimonial/3/1.jpg" alt="Testimonial member 1" className="testimonial3__img" />
                                <img src="assets/imgs/testimonial/3/2.jpg" alt="Testimonial member 2" className="testimonial3__img-2" />
                                <img src="assets/imgs/testimonial/3/3.jpg" alt="Testimonial member 3" className="testimonial3__img-3" />
                                <img src="assets/imgs/testimonial/3/4.jpg" alt="Testimonial member 4" className="testimonial3__img-4" />
                                <img src="assets/imgs/testimonial/3/5.jpg" alt="Testimonial member 5" className="testimonial3__img-5" />
                                <img src="assets/imgs/testimonial/3/6.jpg" alt="Testimonial member 6" className="testimonial3__img-6" />
                            </div>
                        </section>
                        {/* <!-- Testimonial area end --> */}


                        {/* <!-- Workflow area start --> */}
                        <section className="workflow__area-3 " >
                            <div className="workflow__wrapper-3">
                                <div style={{ alignItems: 'normal', paddingTop: '100px' }} className="choose-wrapper wf_panel" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xxl-12">
                                                <div className="choose-title-wrapper">
                                                    <h2 className="choose-title title-anim">why <br /> choose us</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="research__area wf_panel pt-150">
                                    <div className="container inner_content">
                                        <div className="row">
                                            <div className="col-xxl-6 col-xl-6 col-lg-6">
                                                <div className="sec-title-wrapper">
                                                    <h2 className="sec-sub-title">why <br />choose us</h2>
                                                    <h3 className="sec-title">Sacesta</h3>
                                                    <p>With Sacesta, you can be confident that your digital presence is not just beautiful, but also functional and effective. We believe in empowering our clients by educating and mentoring them to achieve their project or product goals. Contact us today to discuss your project and unlock the full potential of your online brand.

                                                    </p>
                                                </div>
                                                <ul className="research__tools">
                                                    <li><a href="https://g.co/kgs/gjksrbD">Google</a></li>
                                                    <li><a
                                                        href="https://www.linkedin.com/company/sacesta">LinkedIn</a>
                                                    </li>
                                                    <li><a href="https://www.instagram.com/sacesta_technologies/">Instagram</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-xxl-6 col-xl-6 col-lg-6">
                                                <div className="research__list">
                                                    <div className="research__item">
                                                        <div className="research__number">
                                                            <span>Rapid</span>
                                                        </div>
                                                        <div className="research__info">
                                                            <h4 className="research__title">4 Weeks</h4>
                                                            <p>Our experts are well in tune with a rapid development workflow that helps you take your idea and convert it into a reality and deploy within a mere 4 weeks time!.</p>
                                                        </div>
                                                    </div>

                                                    <div className="research__item">
                                                        <div className="research__number">
                                                            <span>ONLINE</span>
                                                        </div>
                                                        <div className="research__info">
                                                            <h3 className="research__title">5 minutes</h3>
                                                            <p>With our lightning-fast mini website development, every Indian business can establish its online presence in just 5 minutes.</p>
                                                        </div>
                                                    </div>

                                                    <div className="research__item">
                                                        <div className="research__number">
                                                            <span>90%</span>
                                                        </div>
                                                        <div className="research__info">
                                                            <h4 className="research__title">20+ technologies</h4>
                                                            <p>We are pioneers in the digital realm, equipped with the latest and robust technologies ready to be deployed to cater to our customers’ custom requirements. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="counter__area-3 wf_panel">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xxl-12">
                                                <div className="sec-title-wrapper">
                                                    <h2 className="sec-sub-title">Why <br />Choose Us</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5">
                                                <div className="counter__wrapper-3">
                                                    <div className="counter__item-3">
                                                        <h2 className="counter__number">41+</h2>
                                                        <p>Features  <br />Planned</p>
                                                    </div>
                                                    <div className="counter__item-3">
                                                        <h2 className="counter__number">900+</h2>
                                                        <p>Hours of  <br />Creation</p>
                                                    </div>
                                                    <div className="counter__item-3">
                                                        <h2 className="counter__number">890+</h2>
                                                        <p>Lines of  <br />code daily</p>
                                                    </div>
                                                    <div className="counter__item-3">
                                                        <h2 className="counter__number">1200+</h2>
                                                        <p>Work  <br />Hours</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7">
                                                <div className="counter__img-3">
                                                    <img src="assets/imgs/thumb/counter-3.jpg" alt="Counter" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <!-- CTA area start --> */}
                                <div className="cta__area-3 wf_panel">
                                    <div className="container pt-150 pb-150">
                                        <div className="row">
                                            <div className="col-xxl-12">
                                                <div className="cta__content-3">
                                                    <p className="cta__sub-title-2">Tired of the hustle?</p>
                                                    <h2 className="cta__title-2">At Sacesta, we believe in achieving more while doing less. Let us handle the heavy lifting so you can focus on what truly matters.</h2>
                                                    <div className="btn_wrapper">
                                                        <a href="https://calendly.com/sacesta/30min"
                                                            className="wc-btn-black btn-hover btn-item"><span></span>Start your
                                                            <br />journey
                                                            today <i className="fa-solid fa-arrow-right"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- CTA area end --> */}

                            </div>
                        </section>
                        {/* <!-- Workflow area end --> */}


                        {/* <!-- Roll area start --> */}
                        <section className="roll__area">
                            <div className="swiper roll__slider">
                                <div className="swiper-wrapper roll__wrapper">
                                    <div className="swiper-slide roll__slide">
                                        <h2>Development</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Studio</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Strategy</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Branding</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Agency</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>UI / UX</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Design</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Marketing</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Google Ads</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>App Development</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Strategy</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Branding</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Agency</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Web Development</h2>
                                    </div>
                                    <div className="swiper-slide roll__slide">
                                        <h2>Digital Solution</h2>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </main>

                    {/* <?php include "includes/main_footer.php"; ?> */}
                    <MainFooter />
                </div>
            </div>
            {/* <?php include "includes/js.php"; ?> */}
        </>
    );
}

export default Home